<template>
    <b-modal id="stacked-moments-modal"
             :visible="true"
             size="lg"
             hide-footer
             @hidden="$emit('close')">
        <template #modal-title>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="modalTitle" />
            <!-- eslint-enable-next-line vue/no-v-html -->
        </template>
        <b-list-group>
            <b-list-group-item v-for="item in items"
                               :key="item.id"
                               :button="!item.ending && getMomentStatus(item)"
                               :class="{ 'ending-soon': item.ending }"
                               class="d-flex justify-content-between align-items-center"
                               @click="openReservationModal(item)">
                <div>
                    <div>
                        <strong>
                            {{ format(new Date(item.start), 'HH:mm') }} - {{ format(new Date(item.originalEnd || item.end), 'HH:mm') }}
                        </strong>
                    </div>
                    <div v-if="item.extendedProps['Location.Name']"
                         class="small">
                        {{ item.extendedProps['Location.Name'] }}
                    </div>
                    <div v-if="getMomentStatus(item)?.date">
                        <span v-if="getMomentStatus(item)?.identification === 'reservations_open_at' || getMomentStatus(item)?.identification === 'reservations_closed_at'"
                              class="text-info">
                            <font-awesome-icon :icon="icons.faInfoCircle" />
                            {{ $t('timetable.' + getMomentStatus(item).identification, { date: format(getMomentStatus(item).date,
                                                                                                      new Date(getMomentStatus(item).date).toDateString() === new Date().toDateString()
                                                                                                          ? `HH:mm`
                                                                                                          : `dd-MM-yyyy '${$t('common.at')}' HH:mm`
                            ) }) }}
                        </span>
                    </div>
                </div>
                <template v-if="getMomentStatus(item)">
                    <div>
                        <b-button size="sm"
                                  :variant="getMomentStatus(item).variant"
                                  :disabled="!getMomentStatus(item).canReserve"
                                  @click.stop="openReservationModal(item)">
                            {{ getMomentStatus(item).text }}
                            <span v-if="getMomentStatus(item).showQueueCount && item.extendedProps.QueueQuantity > 0"
                                  class="badge badge-pill badge-light">
                                {{ item.extendedProps.QueueQuantity }}
                            </span>
                        </b-button>
                    </div>
                </template>
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>

<script>
import { format } from 'date-fns'
import reservationStatusMixin from './mixins/reservationStatusMixin'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'StackedMomentsModal',

  components: {
    FontAwesomeIcon
  },

  mixins: [reservationStatusMixin],

  props: {
    mainItem: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isStackedMomentsModal: true,
      format,
      icons: {
        faInfoCircle
      },
      dontAllowReservationForIds: [
        'reservations_open_at',
        'reservations_closed_at'
      ]
    }
  },

  computed: {
    items () {
      if (!this.mainItem) return []

      return [
        this.mainItem,
        ...this.mainItem.children
      ].map(item => ({
        ...item,
        ending: this.isEventPassed(item)
      })).sort((a, b) => new Date(a.start) - new Date(b.start))
    },

    modalTitle () {
      if (!this.items.length) return ''
      const name = this.items[0]?.extendedProps?.Name?.toLowerCase() || ''
      return this.$t('stackedmomentsmodal.title', { name })
    }
  },

  methods: {
    isEventPassed (event) {
      const now = new Date()
      const eventEnd = new Date(event.end)

      return eventEnd <= now
    },

    openReservationModal (item) {
      if (item.ending ||
          !this.getMomentStatus(item) ||
          this.dontAllowReservationForIds.includes(this.getMomentStatus(item)?.identification)) return
      this.$emit('select-moment', {
        moment: item,
        stacked: this.mainItem.children?.length ? this.mainItem : false
      })
    }
  }
}
</script>
